export const BREAKPOINTS = {
	SMALL_DESKTOP: 768,
	MEDIUM_DESKTOP: 996,
	LARGE_DESKTOP: 1200,
	VERY_LARGE_DESKTOP: 1600
};

export const COLORS = {
	PRIMARY: '#2c6fa1',
	ACCENT: '#1a6b60',
	BACKGROUND: '#fff',
	TEXT: '#000',
	GREY: '#666',
	SHADOW: 'rgba(0, 0, 0, 0.5)'
};

export const OPACITIES = {
	TEXT: {
		PRIMARY: 0.85,
		SECONDARY: 0.56,
		DISABLED: 0.24
	},
	PRIMARY: 1,
	SECONDARY: 0.75,
	DISABLED: 0.25
};
